import request from "@/utils/request";
import store from "@/store/index.js";

// 绑定手机号码
export function bindPhone(data) {
  return request({
    url: "/v3/iw-framework/user/bindPhone",
    method: "POST",
    data: { data }
  });
}

// 绑定邮箱
export function bindEmail(data) {
  return request({
    url: "/v3/iw-framework/user/bindEmail",
    method: "POST",
    data: { data }
  });
}

// 获取用户信息
export function getUserInfo(data) {
  return request({
    url: "/v3/iw-framework/user/getUserInfo",
    method: "POST",
    data: { data }
  });
}

// 新建用户
export function saveUser(data) {
  return request({
    url: "/v3/iw-framework/user/saveUser",
    method: "POST",
    data: { data }
  });
}

//
export function sendMessage(params) {
  return request({
    url: "/v3/iw-message/login/get-verification-code",
    method: "get",
    params: params
  });
}

// 切换账号
export function switchAccount(data) {
  return request({
    url: "/v3/iw-framework/login/switch-account",
    method: "post",
    data: { data }
  });
}

/**
 * 短信发送 Sms Controller
 */

// 发送绑定手机验证码
export function sendBindCode(data) {
  return request({
    url: "/v3/iw-message/sms/sendBindCode",
    method: "POST",
    data: { data }
  });
}

// 发送手机登录验证码短信
export function sendVerificationCode(data) {
  return request({
    url: "/v3/iw-message/sms/sendVerificationCode",
    method: "POST",
    data: { data }
  });
}

// 验证邮件&验证码
export function smsValidate(data) {
  return request({
    url: "/v3/iw-message/sms/validate",
    method: "POST",
    data: { data }
  });
}

/**
 * 邮件管理器 Email Controller
 */

// 发送绑定邮件验证码
export function sendBindCodeEmail(data) {
  return request({
    url: "/v3/iw-message/email/sendBindCodeEmail",
    method: "POST",
    data: { data }
  });
}

// 发送常用邮件
export function sendNormalEmail(data) {
  return request({
    url: "/v3/iw-message/email/sendNormalEmail",
    method: "POST",
    data: { data }
  });
}

// 发送登录验证码邮件&验证码
export function sendVerificationCodeEmail(data) {
  return request({
    url: "/v3/iw-message/email/sendVerificationCodeEmail",
    method: "POST",
    data: { data }
  });
}

// 验证邮件&验证码
export function emailValidate(data) {
  return request({
    url: "/v3/iw-message/email/validate",
    method: "POST",
    data: { data }
  });
}

// 是否有广汽研入口权限
export function getGaeiPrivil(
  params = {
    token: store.getters.token /* , userId: store.getters.user.userId */
  }
) {
  return request({
    url: "/v3/iw-framework/external/getGaeiPrivil",
    method: "POST",
    data: {},
    params
  });
}

export default {
  bindPhone,
  bindEmail,
  getUserInfo,
  saveUser
};
